import { RUNTIME_ENV_CONSTANT } from './constants';

declare global {
  interface Window {
    __ENV?: Record<string, string>;
  }
}

const env = (key: string): string | undefined => {
  if (typeof window !== 'undefined') return window[RUNTIME_ENV_CONSTANT]?.[key];

  return process.env[key];
};

const DEFAULT_BASE_URL = 'https://app.constantcontact.com';

/**
 * Gets the base URL for Constant Contact with fallback to default production URL
 * @returns The base URL from NEXT_PUBLIC_URL_CTCT env variable or the default production URL
 */
const getBaseUrl = (): string => {
  return env('NEXT_PUBLIC_URL_CTCT') ?? DEFAULT_BASE_URL;
};

export { env, getBaseUrl };
